/**
 * Zoom con lupa: cuadrado sobre la imagen principal + panel lateral ampliado.
 * Solo se activa en desktop (> 1024px). Requiere data-zoom-style="lens" en
 * .productView-image-wrapper, data-lens-zoom-image en .media y un
 * [data-lens-result] como panel de resultado.
 */
(function () {
    var ZOOM_FACTOR = 2.5;
    var DESKTOP_MIN_WIDTH = 1025;

    function setupWrapper(wrapper) {
        var resultPanel = wrapper.querySelector('[data-lens-result]');
        if (!resultPanel) return;

        var mediaEls = wrapper.querySelectorAll('.media[data-lens-zoom-image]');
        mediaEls.forEach(function (media) {
            if (media.dataset.lensZoomBound) return;
            media.dataset.lensZoomBound = 'true';
            bindMedia(media, resultPanel);
        });
    }

    function bindMedia(media, resultPanel) {
        var square = document.createElement('div');
        square.className = 'product-lens-square';
        media.appendChild(square);

        function fitPanelWidth() {
            // Limitar el ancho del panel al espacio que queda entre su borde
            // izquierdo y el borde del viewport, para que no se corte.
            resultPanel.style.maxWidth = '';
            var panelLeft = resultPanel.getBoundingClientRect().left;
            var available = window.innerWidth - panelLeft - 20;
            if (available > 0) resultPanel.style.maxWidth = available + 'px';
        }

        function updatePosition(event) {
            var rect = media.getBoundingClientRect();
            fitPanelWidth();
            var resultRect = resultPanel.getBoundingClientRect();
            if (!rect.width || !rect.height || !resultRect.width || !resultRect.height) return;

            var squareW = resultRect.width / ZOOM_FACTOR;
            var squareH = resultRect.height / ZOOM_FACTOR;
            square.style.width = squareW + 'px';
            square.style.height = squareH + 'px';

            var x = event.clientX - rect.left - squareW / 2;
            var y = event.clientY - rect.top - squareH / 2;
            x = Math.max(0, Math.min(x, rect.width - squareW));
            y = Math.max(0, Math.min(y, rect.height - squareH));
            square.style.left = x + 'px';
            square.style.top = y + 'px';

            var maxX = rect.width - squareW;
            var maxY = rect.height - squareH;
            var bgX = maxX > 0 ? (x / maxX) * 100 : 0;
            var bgY = maxY > 0 ? (y / maxY) * 100 : 0;

            resultPanel.style.backgroundSize = (rect.width * ZOOM_FACTOR) + 'px ' + (rect.height * ZOOM_FACTOR) + 'px';
            resultPanel.style.backgroundPosition = bgX + '% ' + bgY + '%';
        }

        media.addEventListener('mouseenter', function (event) {
            if (window.innerWidth < DESKTOP_MIN_WIDTH) return;
            resultPanel.style.backgroundImage = 'url(' + media.getAttribute('data-lens-zoom-image') + ')';
            resultPanel.classList.add('is-active');
            square.classList.add('is-active');
            updatePosition(event);
        });

        media.addEventListener('mousemove', function (event) {
            if (window.innerWidth < DESKTOP_MIN_WIDTH) return;
            updatePosition(event);
        });

        media.addEventListener('mouseleave', function () {
            resultPanel.classList.remove('is-active');
            square.classList.remove('is-active');
        });
    }

    function init() {
        if (window.innerWidth < DESKTOP_MIN_WIDTH) return;
        document.querySelectorAll('.productView-image-wrapper[data-zoom-style="lens"]').forEach(setupWrapper);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
